import { $el } from 'src/scripts/utils/utils'
import { isTouch } from 'src/scripts/utils/check-media'
import { BaseComponent } from '../base-component'

const CLASS_OPENED = 'custom-select--opened'
const SELECTOR_SELECT = '.custom-select > select'

export class CustomSelect extends BaseComponent {
  $select: HTMLSelectElement

  mountComponent(): void {
    super.mountComponent()

    this.$select = $el(SELECTOR_SELECT, this)
    this.addListener(this.$select, 'mousedown', this.handleMouseDown)
  }

  unmountComponent(): void {
    super.unmountComponent()

    this.removeListener(this.$select, 'mousedown', this.handleMouseDown)
  }

  handleMouseDown = () => {
    if (isTouch()) {
      return
    }

    this.classList.toggle(CLASS_OPENED, true)
    this.addListener(window, 'click', this.handleWindowClick, { once: true })
  }

  handleWindowClick = () => {
    this.classList.toggle(CLASS_OPENED, false)
  }
}
